import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Manifesto from "@/components/landing/Manifesto";
import Features from "@/components/landing/Features";
import BetaStatusSection from "@/components/landing/BetaStatusSection";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-cream">
      <Navbar />
      <Hero />
      <Manifesto />
      <Features />
      <BetaStatusSection />
      <Footer />
    </div>
  );
}
